<h2>Resend code</h2>
<ng-container *ngIf="otpService.otpRecipients.length == 1">
  <p>
    We will send a code to your mobile number <span [style.white-space]="'nowrap'">{{otpService.otpRecipients[0].mobilePhone}}.</span>
    Please enter your code to verify your identity.
  </p>
</ng-container>
<ng-container *ngIf="otpService.otpRecipients.length > 1">
  <p>Please check you have chosen the correct mobile number to receive your security code.</p>
  <form [formGroup]="otpSendForm" fxLayout="column">
    <div fxLayout="row wrap" fxLayoutGap.xs="0" fxLayoutGap.gt-xs="20px">
      <mat-form-field appearance="outline" class="standard-input" fxFlex="" fxFlex.xs="100">
        <mat-select formControlName="contactId">
          <mat-option *ngFor="let otpRecipient of otpService.otpRecipients" [value]="otpRecipient.contactId">
            {{otpRecipient | otpRecipientDisplay}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>
</ng-container>
<div fxLayout="row wrap" class="form-row-container" fxLayoutGap.xs="0" fxLayoutGap.gt-xs="20px">
  <button *ngIf="otpService.sending" mat-button [disabled]="true" fxFlex.xs="100" fxFlexOrder.xs="0" fxFlexOrder.gt-xs="2">
    <span class="loading-icon-bubbles">Sending...</span>
  </button>
  <button *ngIf="!otpService.sending" id="send-button" class="btn-chevron" mat-raised-button color="action" (click)="sendOtp()" fxFlex.xs="100" fxFlexOrder.xs="0" fxFlexOrder.gt-xs="2">
    <span>Resend code</span>
    <mat-icon fontSet="iinet-icons" fontIcon="iii-point-thin"></mat-icon>
  </button>
  <button id="cancel-button" mat-raised-button color="secondary" (click)="back()" fxFlex.xs="100" fxFlexOrder.xs="2" fxFlexOrder.gt-xs="0">
    Back
  </button>
</div>

